import {routeContainsVerb} from '../../../lib/corpMaxRouteMatcher'

export const elementIdForFirstTab = topKit => topKit.getIn(['elements', 0, 'id'])

export const isContactCardVisible = ({currentUser, location, router}) => (
  currentUser?.client && (router.isActive('cm/dashboard') || routeContainsVerb(location, ['category']))
)
